import React, { useState } from "react"
import PropTypes from 'prop-types'
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter"
import { useTenant } from "../../../hooks/useTenant";

// users
import user1 from "../../../assets/images/users/user-1.jpg"

const ProfileMenu = props => {
  const [menu, setMenu] = useState(false)
  const { user } = useTenant();

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item waves-effect d-flex align-items-center"
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={user?.photoURL || user?.picture || user1}
            alt="Header Avatar"
            style={{ border: '2px solid rgba(255, 255, 255, 0.2)' }}
          />
          <div className="d-none d-sm-flex flex-column align-items-start ms-2 text-start">
            <span className="profile-user-name">{user?.displayName || user?.fullName || "Usuário"}</span>
            <span className="font-size-11 text-white-50 mt-1">{user?.email || ""}</span>
          </div>
          <i className="mdi mdi-chevron-down d-none d-sm-block ms-2 text-white-50"></i>
        </DropdownToggle>

        <DropdownMenu
          className="dropdown-menu-end shadow-lg"
          container="body"
          style={{
            minWidth: '260px',
            padding: '12px',
            backgroundColor: '#020308',
            border: '1px solid rgba(255, 255, 255, 0.12)',
            borderTop: 'none',
            borderTopLeftRadius: '0',
            borderTopRightRadius: '0',
            borderBottomLeftRadius: '16px',
            borderBottomRightRadius: '16px',
            boxShadow: '0 12px 32px rgba(0, 0, 0, 0.5)',
            marginTop: '0.5px' // Ajuste fino para colar exatamente embaixo da borda da header
          }}
        >
          {/* Menu Header */}
          <div className="px-3 py-2 d-flex flex-column mb-2">
            <span className="profile-user-name mb-1">{user?.displayName || user?.fullName || "Usuário"}</span>
            <span className="font-size-12 text-white-50 text-truncate">{user?.email || "Sem e-mail"}</span>
          </div>

          <div className="dropdown-divider border-0" style={{ borderTop: '1px solid rgba(255, 255, 255, 0.1)' }} />

          {/* Profile Item */}
          <DropdownItem tag={Link} to="/profile" className="rounded-3 px-3 py-2 mt-2 mb-1 d-flex align-items-center fw-medium text-white header-item bg-transparent" style={{ height: 'auto' }}>
            <div className="avatar-xs me-3">
              <span className="avatar-title rounded-circle font-size-16" style={{ backgroundColor: 'rgba(0, 209, 255, 0.1)', color: '#00d1ff' }}>
                <i className="mdi mdi-account-outline" />
              </span>
            </div>
            {props.t("Meu Perfil")}
          </DropdownItem>

          {/* Settings Item */}
          <DropdownItem tag={Link} to="#" className="rounded-3 px-3 py-2 mb-2 d-flex align-items-center fw-medium text-white header-item bg-transparent" style={{ height: 'auto' }}>
            <div className="avatar-xs me-3">
              <span className="avatar-title rounded-circle font-size-16" style={{ backgroundColor: 'rgba(255, 255, 255, 0.05)', color: '#f1f5f9' }}>
                <i className="mdi mdi-cog-outline" />
              </span>
            </div>
            {props.t("Configurações")}
          </DropdownItem>

          <div className="dropdown-divider border-0 my-2" style={{ borderTop: '1px solid rgba(255, 255, 255, 0.1)' }} />

          {/* Logout Item */}
          <DropdownItem tag={Link} to="/logout" className="rounded-3 px-3 py-2 d-flex align-items-center fw-bold header-item bg-transparent" style={{ height: 'auto', color: '#ff4400' }}>
            <div className="avatar-xs me-3">
              <span className="avatar-title rounded-circle font-size-16" style={{ backgroundColor: 'rgba(255, 68, 0, 0.1)', color: '#ff4400' }}>
                <i className="mdi mdi-logout" />
              </span>
            </div>
            <span>{props.t("Sair do Sistema")}</span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(ProfileMenu));